export const PLANNER_LOCAL_DATA_KEY = 'PLANNER_LOCAL_DATA_KEY';
